import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-view-dialog',
  templateUrl: './image-view-dialog.component.html',
  styleUrls: ['./image-view-dialog.component.css']
})
export class ImageViewDialogComponent implements OnInit {
  ngOnInit() {
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string },
    public dialogRef: MatDialogRef<ImageViewDialogComponent>,
  ) {
  }

  handleClose() {
    this.dialogRef.close();
  }
}
